<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF AMEND CHANGES</b></h5>
    <hr />
    <TableStockoutChangesIndex :fields="fields.fields" :items="items" />
  </b-card>
</template>

<script>
import TableStockoutChangesIndex from "@/table/admin/stockoutChanges/TableStockoutChangesIndex";
export default {
  data() {
    return {
      items: [],
      fields: {
        fields: [
          {
            label: "No",
            key: "no",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Type",
            key: "category",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Product Type",
            key: "pro_cat",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Status",
            key: "status",
            sortable: true
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },
  created() {
    this.getSC();
  },
  methods: {
    getSC() {
      this.$store.dispatch("getSC", 5).then(res => {
        let no = 0;
        res.data.data.forEach(element => {
          no = no + 1;

          let type = element.type === 1 ? "UHT" : "Pasteurized";
          this.items.push({
            no: no,
            name: element.userdetails.name,
            status: element.status,
            date: element.date_request,
            action: "fas fa-trash",
            id: element.amend_changes_id,
            pro_cat: type,
            type: element.type,
            category: element.category
          });
        });
        this.totalRows = this.items.length;
      });
    }
  },
  components: {
    TableStockoutChangesIndex
  }
};
</script>
<style lang="css" scoped></style>
